import { render, staticRenderFns } from "./CreditNoteSupplier.vue?vue&type=template&id=4bc7c628"
import script from "./CreditNoteSupplier.vue?vue&type=script&lang=js"
export * from "./CreditNoteSupplier.vue?vue&type=script&lang=js"
import style0 from "./CreditNoteSupplier.vue?vue&type=style&index=0&id=4bc7c628&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports